import { IMarker, ICoordinate } from "shared/types";

export const getMarkersCenter = (markers: IMarker[]): ICoordinate => {
  const accumulatedCoordinates = markers.reduce(
    (accumulatedCoordinates, marker) => {
      const { longitude, latitude } = marker.coordinates;
      return {
        longitude: accumulatedCoordinates.longitude + longitude,
        latitude: accumulatedCoordinates.latitude + latitude,
      };
    },
    { longitude: 0, latitude: 0 }
  );

  const { length } = markers;
  if (!length) {
    return accumulatedCoordinates;
  }

  return {
    longitude: accumulatedCoordinates.longitude / markers.length,
    latitude: accumulatedCoordinates.latitude / markers.length,
  };
};
